import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type InsightsQuery from "./InsightsQuery";

@Model()
class InsightsKeyTopic extends ApplicationRecord {
  static jsonapiType = "insights_key_topics";

  @Attr() booleanQuery: string;

  @Attr() color: string;

  @BelongsTo() insightsQuery: InsightsQuery;

  @Attr() label: string;
}

export default InsightsKeyTopic;
